import { render } from "./Crest.vue?vue&type=template&id=09337c42"
import script from "./Crest.vue?vue&type=script&lang=js"
export * from "./Crest.vue?vue&type=script&lang=js"

import "./Crest.vue?vue&type=style&index=0&id=09337c42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__